import { render, staticRenderFns } from "./AServicesRecommendationsPanel.vue?vue&type=template&id=e7bb64d0&scoped=true"
import script from "./AServicesRecommendationsPanel.vue?vue&type=script&lang=js"
export * from "./AServicesRecommendationsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7bb64d0",
  null
  
)

export default component.exports